import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import CustomerProfile from './CustomerProfile';
import './NavigationBar.css';

function NavigationBar({ user, cartCount, onCartClick, isAdmin = false }) {
  const [showProfile, setShowProfile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate(isAdmin ? '/admin/login' : '/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleProfileClick = () => {
    setShowProfile(true);
  };

  const customerNavItems = [
    { icon: '🏠', label: 'Home', path: '/' },
    { icon: '📦', label: 'Orders', path: '/orders' },
    { icon: '🛒', label: 'Cart', path: 'cart', isCart: true },
    { icon: '👤', label: 'Profile', action: handleProfileClick },
    { icon: '🔔', label: 'Alerts', path: '/notifications' }
  ];

  // Admin navigation is handled by AdminApp component, not NavigationBar
  const navItems = isAdmin ? [] : customerNavItems;

  const handleNavClick = (item) => {
    if (item.action) {
      item.action();
    } else {
      navigate(item.path);
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-content">
          <div className="navbar-left">
            <div className="logo" onClick={() => handleNavClick(isAdmin ? '/admin' : '/')}>
              <h1>Trini Ting Tees</h1>
            </div>
          </div>

          <div className="navbar-center">
            <div className="nav-links">
              {navItems.map((item, index) => (
                <button
                  key={index}
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => item.isCart ? onCartClick() : handleNavClick(item)}
                >
                  <span className="nav-emoji">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                  {item.isCart && cartCount > 0 && (
                    <span className="cart-badge">{cartCount}</span>
                  )}
                </button>
              ))}
            </div>
          </div>

          <div className="navbar-right">
            {/* Desktop logout button */}
            {!isAdmin && (
              <button className="desktop-logout-btn" onClick={handleLogout}>
                <span className="nav-emoji">🚪</span>
                <span>Sign Out</span>
              </button>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Bottom Navigation */}
      <nav className="mobile-bottom-nav">
        {navItems.map((item, index) => (
          <button
            key={index}
            className={`mobile-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => {
              if (item.isCart) {
                onCartClick();
              } else if (item.action) {
                item.action();
              } else {
                navigate(item.path);
              }
            }}
          >
            <span className="nav-emoji">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
            {item.isCart && cartCount > 0 && (
              <span className="mobile-cart-badge">{cartCount}</span>
            )}
          </button>
        ))}
        
        {/* Mobile logout button */}
        {!isAdmin && (
          <button className="mobile-nav-item logout" onClick={handleLogout}>
            <span className="nav-emoji">🚪</span>
            <span className="nav-label">Logout</span>
          </button>
        )}
      </nav>
    
      {/* Customer Profile Modal */}
      {showProfile && !isAdmin && (
        <CustomerProfile onClose={() => setShowProfile(false)} />
      )}
    </>
  );
}

export default NavigationBar;
